module.exports = __webpack_public_path__ + "7e75f98355d08349ea03dc721319e3ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/airbnb_2022_chart.png
// module id = 1628
// module chunks = 0